'use client';

import {useQuery} from '@tanstack/react-query';
import {getBenefitsByOrgId} from '@/utils/query';
import {Loader} from '@purpose/ui/components/Loader';
import {Typography} from '@purpose/ui/components';
import {LOCALE_CODES, translations} from '@/utils/translations';
import {useSearchParams} from 'next/navigation';
import Content from '@/components/Content';
import {useIframeResize} from '@/utils/hooks';

function Benefits() {
  const ref = useIframeResize();

  const searchParams = useSearchParams();
  const orgId = searchParams.get('o');
  const locale = searchParams.get('locale') as LOCALE_CODES;

  const fetchWidget = async () => {
    const response = (await getBenefitsByOrgId(orgId as string)) as any;
    return response.json();
  };

  const {data, isLoading, error} = useQuery({
    queryKey: ['benefits', orgId],
    queryFn: fetchWidget,
    enabled: !!orgId
  });

  const goToBenefit = (id: number) => () => {
    window.open(
      `${process.env.NEXT_PUBLIC_NEXTAUTH_URL}/${locale}/benefits/${id}`,
      '_blank'
    );
  };
  return (
    <div ref={ref} className="flex w-full flex-col">
      {isLoading ? (
        <div className="flex min-h-[200px] w-full items-center justify-center">
          <Loader />
        </div>
      ) : error || !data?.data ? (
        <div className="flex min-h-[200px] w-full items-center justify-center p-4">
          <Typography variant="body2">
            {data?.status === 404
              ? translations[locale || LOCALE_CODES.NO].errors.notFound
              : translations[locale || LOCALE_CODES.NO].errors.unexpected}
          </Typography>
        </div>
      ) : (
        <>
          <Content
            title={data?.data?.show_title && data?.data?.title_text}
            titleSize={data?.data?.title_size}
            titleWeight={data?.data?.title_weight}
            radius={data?.data?.card_corner_radius}
            color={data?.data?.color}
            layout={data?.data?.layout}
            benefits={data?.data?.benefits}
            onClick={goToBenefit}
          />
          <Typography
            variant="body1"
            className="mt-4 ml-auto text-[#353E4B]/[0.47]"
          >
            {translations[locale || LOCALE_CODES.NO].poweredByPurpose}
          </Typography>
        </>
      )}
    </div>
  );
}

export default Benefits;
